import React from "react";
import { hydrate, render } from "react-dom";
import App from "./pages/App/App";
import * as serviceWorker from "./serviceWorker";

const rootElement = document.getElementById("root");

if (rootElement.hasChildNodes()) {
  hydrate(<App />, rootElement);
} else {
  render(<App />, rootElement);
}

serviceWorker.register(); // unregister()
